module.exports = __webpack_public_path__ + "static/media/img.18151024.png";